!function (t) {
    var e = {
            common: {
                init: function () {
                    this.matchHeights(), this.triggers(), this.menuHover(), this.pushMenu(), this.dropdowns(), this.multimediaTabs(), this.flippingNumbers(), this.stickyKit(), this.quantityButton(), this.videoplay(), this.downloadFile(), t("body").hasClass("page-template-template-basket") && this.basket(), t(".text-content-wysiwyg p iframe").wrap('<div class="embed-video" />')
                },
                finalize: function () {
                },
                downloadFile: function () {
                    t(document).on("click", "a[download]", function (e) {
                        if (void 0 == document.createElement("a").download && e.target.hasAttribute("download")) {
                            e.preventDefault();
                            var i = moove_front_end_scripts.ajaxurl + "?action=qube_download_file&file=" + t(this).attr("href");
                            window.open(i, "_blank")
                        }
                    })
                },
                videoplay: function () {
                    function e() {
                        var t = ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"];
                        if (navigator.platform)
                            for (; t.length;)
                                if (navigator.platform === t.pop()) return !0;
                        return !1
                    }

                    jQuery.fn.isFullyVisible = function () {
                        var e = t(window),
                            i = {
                                top: e.scrollTop(),
                                left: e.scrollLeft()
                            };
                        i.right = i.left + e.width(), i.bottom = i.top + e.height();
                        var s = this.height();
                        s = Math.round(s);
                        var n = this.offset();
                        return n.top = n.top + s, n.right = n.left + this.outerWidth(), n.bottom = n.top + this.outerHeight(), !(i.right < n.left || i.left > n.right || i.bottom < n.top || i.top > n.bottom)
                    }, t(window).scroll(function () {
                        t(".multimedia-box video").each(function () {
                            t(".multimedia-box .tab-content .container").isFullyVisible() ? t(this)[0].paused && !e() && t(this)[0].play() : t(this)[0].paused || e() || t(this)[0].pause()
                        })
                    })
                },
                matchHeights: function () {
                    t(".staff .profile").matchHeight({
                        byRow: !0
                    }), t(".section.software-solutions .solution-box").matchHeight({
                        byRow: !0
                    }), t("footer.main-footer .widget-match-height").matchHeight({
                        byRow: !1
                    }), t("section.event-details .event-details-table ul li.table-data").matchHeight({
                        byRow: !1
                    }), t(".group-list .group-item").matchHeight({
                        byRow: !0
                    })
                },
                triggers: function () {
                    function i(t, e, i, s) {
                        var n = window.top.outerHeight / 2 + window.top.screenY - s / 2,
                            o = window.top.outerWidth / 2 + window.top.screenX - i / 2,
                            a = window.open(t, e, "toolbar=no, location=no, directories=no, status=no, menubar=no, scrollbars=no, resizable=no, copyhistory=no, width=" + i + ", height=" + s + ", top=" + n + ", left=" + o),
                            r = window.setInterval(function () {
                                try {
                                    (null == a || a.closed) && window.clearInterval(r)
                                } catch (t) {
                                }
                            }, 1e3);
                        return a
                    }

                    var s = jQuery("body"),
                        n = function (e) {
                            "mousedown" === e.type || "touchstart" === e.type && t(".scroller a").each(function () {
                                t(this).addClass("qube-no-hover")
                            }), s.off("mousedown touchstart", n)
                        };
                    s.on("mousedown touchstart", n), t(window).resize(function () {
                        e.common.matchHeights()
                    }), t(document).on("change", ".qube-multistep-form-wizard form input", function () {
                        t(window).trigger("resize")
                    });
                    t(".event-register-content iframe").attr("height", "270"), t("#become-a-member iframe").attr("height", "270"), t("#booking-form-holder iframe").attr("height", "270");
                    var o = window.addEventListener ? "addEventListener" : "attachEvent";

                    (0, window[o])("attachEvent" === o ? "onmessage" : "message", function (t) {

                    }, !1), t(document).on("click", ".scroll-down-button", function (e) {
                        e.preventDefault();
                        var i = t(this).closest("section").next();
                        t("html, body").animate({
                            scrollTop: i.offset().top - 65
                        }, "slow", "swing", function () {
                        })

                    }), t(document).on("click", ".content-scroll-up-button", function (e) {
                        e.preventDefault(), t("html, body").animate({
                            scrollTop: t(".main-section-holder").offset().top
                        }, "slow", "swing", function () {
                        })
                    }), t(document).on("click", ".social-share-buttons-secondary a, .social-share-buttons a", function (e) {
                        if (!t(this).closest("li").hasClass("mail-icon")) {
                            e.preventDefault();
                            var s = 600,
                                n = 500;
                            "linkedin" === t(this).attr("data-type") && (s = 1e3, n = 700), i(t(this).attr("href"), t(this).attr("title"), s, n)
                        }
                    }), t(document).on("click", ".search-desktop-toggle", function (e) {
                        e.preventDefault(), t(".pusher").toggleClass("search-desktop-open"), t(".search-form-cnt input").focus()
                    }), t(document).on("click", ".pusher.search-desktop-open .scroller", function () {
                        t(".pusher").removeClass("search-desktop-open")
                    }), t("header.main-header").on("affix.bs.affix", function () {
                        t(".pusher").removeClass("search-desktop-open")
                    }), t(window).resize(function () {
                        t(".qube-flipping-animate-item").css("width", "auto")
                    }), t(document).on("click", ".scroller a[href*=\\#]", function (e) {
                        var i = t(this).attr("href");
                        t(i).length > 0 && "pill" !== t(this).attr("data-toggle") && !t(this).hasClass("google-map") && !t(this).hasClass("service-nav-link") ? (e.preventDefault(), t("html,body").animate({
                            scrollTop: t(this.hash).offset().top - 65
                        }, 500)) : t(this).hasClass("service-nav-link") && (e.preventDefault(), t("html,body").animate({
                            scrollTop: t(this.hash).offset().top - 130
                        }, 500))
                    })
                },
                menuHover: function () {
                    function e() {
                        screen.width > 1010 && (t("#primary-navigation li.dropdown").hover(function () {
                            t(this).addClass("open");
                        }, function () {
                            t(this).removeClass("open")
                        }), t("#primary-navigation li.dropdown a.dropdown-toggle").on("click", function (e) {
                            e.preventDefault(), e.stopPropagation();
                            var i = t(this).attr("href");
                            i.length > 1 && t(location).attr("href", i)
                        }))
                    }

                    e(), t(window).resize(function () {
                        e()
                    })
                },
                pushMenu: function () {
                    t("#primary-navigation .toggle").on("click", function (e) {
                        e.preventDefault(), t(this).toggleClass("collapsed"), t("html").toggleClass("menu-open")
                    });
                    var e = t(".pushmenu .push-cnt").find("li.button-menu-item");
                    if (e.length > 0) {
                        var i = e[0].outerHTML;
                        e.remove(), t(".pushmenu .push-cnt ul").append(i)
                    }
                    t(".pushmenu li:has(ul)").addClass("nav-col"), t(".nav-col a").click(function () {
                        t(".push-cnt ul, .pushmenu").scrollTop(0), t(this).hasClass("back") ? t(".push-cnt").is(".level2") ? (t(".nav-col.passive").removeClass("passive"), t(".push-cnt").removeClass("level2"), t("ul li ul li.nav-col").removeClass("active")) : (t(".push-cnt").removeClass("level1"), t("li.nav-col").removeClass("active")) : (t(this).parent().addClass("active"), t(".push-cnt").addClass("level1"))
                    }), t("ul li ul li.nav-col>a").click(function () {
                        t(this).hasClass("back") || (t("li.nav-col.active").first().addClass("passive"), t("ul li ul li.nav-col").addClass("active"), t(".push-cnt").addClass("level2"))
                    }), t(".pushmenu .push-collapse").on("click", function (t) {
                        t.preventDefault()
                    }), t(".pushmenu .back").on("click", function (t) {
                        t.preventDefault()
                    })
                },
                dropdowns: function () {

                },
                multimediaTabs: function () {
                    function e() {
                        var t = ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"];
                        if (navigator.platform)
                            for (; t.length;)
                                if (navigator.platform === t.pop()) return !0;
                        return !1
                    }

                    function i() {
                        return window.innerWidth <= 800 && window.innerHeight <= 600
                    }

                    t(function () {
                        var e, i, s = "fadeInLeft";
                        t("a[rel=popover]").popover().click(function (e) {
                            e.preventDefault(), void 0 !== t(this).data("easein") ? t(this).next().removeClass(t(this).data("easein")).addClass("animated " + t(this).data("easein")) : t(this).next().addClass("animated " + s)
                        }),
                            function (n, o, a) {
                                n.click(function (n) {
                                    n.preventDefault(), t(this).tab("show");
                                    var r = t(this).data("easein");
                                    e && e.removeClass(i), r ? (o.find("div.active").addClass("animated " + r), i = r) : a ? (o.find("div.active").addClass("animated " + a), i = a) : (o.find("div.active").addClass("animated " + s), i = s), e = o.find("div.active")
                                })
                            }(t(".multimedia-navs a"), t(".multimedia-box .tab-content"))
                    }), t('.multimedia-navs a[data-toggle="pill"]').on("shown.bs.tab", function (s) {
                        var n = t(s.target).attr("href");
                        t(this).closest(".multimedia-box").find(".section-background-content .tab-bg-hld").fadeOut(400), t(this).closest(".multimedia-box").find(".section-background-content video").each(function () {
                            t(this)[0].paused || e() || i() || t(this)[0].pause()
                        }), t(this).closest(".multimedia-box").find('.section-background-content .tab-bg-hld[data-tab="' + n + '"]').fadeIn(400);
                        var o = t(this).closest(".multimedia-box").find('.section-background-content .tab-bg-hld[data-tab="' + n + '"]').find("video");
                        o.length > 0 && !e() && !i() && o[0].paused && o[0].play()
                    })
                },
                flippingNumbers: function () {
                    function e(e) {
                        var i = t(window).scrollTop(),
                            s = i + t(window).height(),
                            n = e.offset().top;
                        return n <= s - 20 && n >= i + 20
                    }

                    function i(i) {
                        if (i) {
                            if (e(i)) {
                                var s = i.attr("data-duration");
                                i.find(".qube-flipping-animate-numbers").addClass("animated"), i.find(".qube-flipping-animate-item").each(function () {
                                    t(this).css("width", t(this).width());
                                    var e = {
                                            useEasing: !1,
                                            useGrouping: !0,
                                            separator: "",
                                            decimal: "",
                                            prefix: "",
                                            suffix: ""
                                        },
                                        i = t(this).attr("data-suffix"),
                                        n = t(this).attr("data-prefix"),
                                        o = t(this).attr("data-number"),
                                        a = t(this).attr("data-grouping"),
                                        r = t(this).attr("data-separator"),
                                        l = 0,
                                        h = t(this).attr("data-decimal");
                                    -1 !== o.indexOf(".") && (l = 1), "true" === a ? (e.useGrouping = !0, e.decimal = h, e.separator = r) : e.useGrouping = !1, "false" !== n && (e.prefix = n), "false" !== i && (e.suffix = i), new CountUp(t(this).find(".qube-flipping-number-cnt")[0], 0, o, l, s, e).start()
                                })
                            }
                        } else t(".qube-flipping-animate-numbers").each(function () {
                            if (e(t(this)) && !t(this).hasClass("animated")) {
                                t(this).addClass("animated");
                                var i = t(this).attr("data-duration");
                                t(this).find(".qube-flipping-animate-item").each(function () {
                                    t(this).css("width", t(this).width());
                                    var e = {
                                            useEasing: !1,
                                            useGrouping: !0,
                                            separator: "",
                                            decimal: "",
                                            prefix: "",
                                            suffix: ""
                                        },
                                        s = t(this).attr("data-suffix"),
                                        n = t(this).attr("data-prefix"),
                                        o = t(this).attr("data-number"),
                                        a = t(this).attr("data-grouping"),
                                        r = t(this).attr("data-separator"),
                                        l = 0,
                                        h = t(this).attr("data-decimal");
                                    -1 !== o.indexOf(".") && (l = 1), "true" === a ? (e.useGrouping = !0, e.decimal = h, e.separator = r) : e.useGrouping = !1, "false" !== n && (e.prefix = n), "false" !== s && (e.suffix = s), new CountUp(t(this).find(".qube-flipping-number-cnt")[0], 0, o, l, i, e).start()
                                })
                            }
                        })
                    }

                    i(), t(window).scroll(function () {
                        i()
                    })
                },
                stickyKit: function () {
                    t("section.training-details .sticky-widget-holder").stick_in_parent({
                        offset_top: 95
                    }), t("section.event-details .sticky-widget-holder").stick_in_parent({
                        offset_top: 95
                    })
                },
                multistepForm: function () {
                    function e() {
                        var e = t("#step-3 .booking-summary"),
                            i = e.find(".summary-box-right .summary-info");
                        i.find(".box-username").html("<strong>" + t("#tr_bk_first_name").val() + " " + t("#tr_bk_last_name").val() + "</strong>"), i.find(".box-mail").html(t("#tr_bk_email").val()), i.find(".box-phone").html(t("#tr_bk_phone").val()), i.find(".box-address").html(t("#tr_bk_address").val() + "<br>" + t("#tr_bk_city").val() + "<br>" + t("#tr_bk_postcode").val() + "<br>" + t("#tr_bk_country").val());
                        var s = e.find(".participants-summary .participant-list"),
                            n = "";
                        t(".participants-form-content .member-row").each(function () {
                            n += "<li>", n += '<span class="name"><strong>', n += t(this).find(".first_name input").val(), n += " ", n += t(this).find(".last_name input").val(), n += "</strong></span>", n += '<span class="email">', n += t(this).find(".email_address input").val(), n += "</span>", n += "</li>"
                        }), s.empty().html(n)
                    }

                    var i = !1,
                        s = t(".tranining-booking-form div.setup-panel div a"),
                        n = t(".tranining-booking-form .setup-content"),
                        o = t(".tranining-booking-form .nextBtn");
                    allPrevBtn = t(".tranining-booking-form button.prevBtn"), n.hide(), s.click(function (o) {
                        o.preventDefault(), o.stopPropagation();
                        var a = t(t(this).attr("href")),
                            r = t(this);
                        if (!r.hasClass("disabled")) {
                            s.removeClass("tab-primary").addClass("tab-default"), r.addClass("tab-primary"), n.hide(), a.show(), a.find("input:eq(0)").focus();
                            var l = 0,
                                h = t("#step-1 .quantity input").val();
                            t(".participants-form-content .member-row").each(function () {
                                ++l > h && t(this).remove()
                            }), t(".participants-form-content .member-row").length < h ? t(".tranining-booking-form .participants-cta-holder a.btn").removeClass("disabled").prop("disabled", !1) : t(".tranining-booking-form .participants-cta-holder a.btn").addClass("disabled").prop("disabled", !0), e(), i ? t("html, body").animate({
                                scrollTop: a.offset().top - t("header.main-header").height() - 100
                            }, "fast") : i = !0
                        }
                    }), allPrevBtn.click(function () {
                        var i = t(this).closest(".setup-content"),
                            s = i.attr("id"),
                            n = t('.tranining-booking-form div.setup-panel div a[href="#' + s + '"]').parent().prev().children("a");
                        i.find("input[type='text'],input[type='url']");
                        n.removeAttr("disabled").removeClass("disabled").trigger("click"), t(".tranining-booking-form div.setup-panel div a.tab-primary").trigger("click"), e()
                    }), o.click(function () {
                        var i = t(this).closest(".setup-content"),
                            s = i.attr("id"),
                            n = t('.tranining-booking-form div.setup-panel div a[href="#' + s + '"]').parent().next().children("a"),
                            o = (i.find("input"), !0),
                            a = t("#booking-main-form");
                        if ("step-2" === s && (o = a.validate(), console.warn(a.valid()), o = a.valid()), o) {
                            n.removeAttr("disabled").removeClass("disabled").trigger("click"), e();
                            var r = 0,
                                l = t("#step-1 .quantity input").val();
                            t(".participants-form-content .member-row").each(function () {
                                ++r > l && t(this).remove()
                            }), t(".participants-form-content .member-row").length < l ? t(".tranining-booking-form .participants-cta-holder a.btn").removeClass("disabled").prop("disabled", !1) : t(".tranining-booking-form .participants-cta-holder a.btn").addClass("disabled").prop("disabled", !0)
                        }
                    }), t(".tranining-booking-form div.setup-panel div a.tab-primary").trigger("click")
                },
                basket: function () {
                    function t() {
                        console.log("generateBillingSummary"), l(".basket .billing-details").html(""), l(".basket .participants-summary .participant-list").html(""), l(".product .item >td:first").text(l(".item:first>td:first").text()), l(".step> li:eq(1) .billing input").each(function () {
                            "country-disabled" === l(this).prop("name") ? l(".basket .billing-details").append('<div class="' + l(this).prop("name") + '"><span class="label">Country: </span> <span>United Kingdom</span></div>') : l(".basket .billing-details").append('<div class="' + l(this).prop("name") + '"><span class="label">' + l(this).parent().find("label").text().replace(" *", "") + ": </span> <span>" + l(this).val() + "</span></div>")
                        }), l(".basket .participants >.participant").each(function () {
                            l(".basket .participants-summary .participant-list").append('<li><span class="name"><strong>' + l(this).find('input[name="pname[]"]').val() + " " + l(this).find('input[name="plname[]"]').val() + '</strong></span><span class="email">' + l(this).find('input[name="pemail[]"]').val() + "</span></li>")
                        }), l(".order-details-cnt-table .shopping-table-holder .shopping-table").empty().append(l("#main-shopping-table").html()).find(".quantity").append('<span class="price-label">' + l('#main-shopping-table input[name="amount"]').val() + "</span>").find('input[name="amount"]').remove(), l(".navigation.step A:eq(1)").hide(), l(".navigation.step A:eq(2)").show()
                    }

                    function e(t) {
                        return "number" == typeof t && Math.round(t) == t
                    }

                    function s(t) {
                        var e = "";
                        if (0 === t) {
                            if (l(".basket input[name=amount]").val() < 1 && (e = "Amount cant be less than 1 ticket.\n"), 1 != l(".basket select[name=country]").val() && (e += "If you would like to book training from outside the UK then please contact our Professional Services team."), "" !== e) return alert(e), !1
                        } else if (1 == t) {
                            var i = !0;
                            return l("ul.step .billing input").each(function () {
                                if ("ponumber" !== l(this).attr("name") && "company" !== l(this).attr("name")) {
                                    l(this).removeClass("error"), l(this).parent().find("span.validation_message").remove();
                                    var t = l(this).attr("placeholder");
                                    value = l.trim(l(this).val()), t = l(this).attr("placeholder"), value == t && l(this).val(""), "" == l.trim(l(this).val()) ? (l(this).addClass("error"), l('<span class="validation_message">Required field.</span>').appendTo(l(this).parent()), i = !1) : "email" != l(this).prop("name") || n(l(this).val()) || (l(this).addClass("error"), l('<span class="validation_message">Wrong Email format.</span>').appendTo(l(this).parent()), i = !1), l(this).hasClass("error") && l(this).val(t)
                                }
                            }), l("ul.step .participants .participant").each(function () {
                                l(this).find("span.validation_message").remove(), l(this).find("input").each(function () {
                                    l(this).removeClass("error"), value = l.trim(l(this).val()), placeholder = l(this).attr("placeholder"), value == placeholder && l(this).val(""), "" == l.trim(l(this).val()) ? l(this).addClass("error") : "pemail[]" != l(this).prop("name") || n(l(this).val()) || (l(this).addClass("error"), l('<span class="validation_message">Wrong Email format.</span>').appendTo(l(this).parent())), l(this).hasClass("error") && l(this).val(placeholder)
                                }), l(this).find("input.error").length > 0 && (l('<span class="validation_message">Required field.</span>').insertAfter(l(this).find("A")), i = !1)
                            }), i
                        }
                        return !0
                    }

                    function n(t) {
                        return new RegExp(/^(("[\w-+\s]+")|([\w-+]+(?:\.[\w-+]+)*)|("[\w-+\s]+")([\w-+]+(?:\.[\w-+]+)*))(@((?:[\w-+]+\.)*\w[\w-+]{0,66})\.([a-z]{2,6}(?:\.[a-z]{2})?)$)|(@\[?((25[0-5]\.|2[0-4][\d]\.|1[\d]{2}\.|[\d]{1,2}\.))((25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\.){2}(25[0-5]|2[0-4][\d]|1[\d]{2}|[\d]{1,2})\]?$)/i).test(t)
                    }

                    var o = 0,
                        a = -1,
                        r = 0,
                        l = jQuery.noConflict();
                    l(".basket-steps").css({
                        height: l(".basket-steps ul.step li:first-child").outerHeight()
                    }), l(window).resize(function () {
                        l(".basket-steps >ul.step").outerWidth(4 * l(".basket-steps-container").width()), l(".basket-steps >ul>li").outerWidth(l(".basket-steps-container").width()), l(".basket-steps").scrollLeft(l(".basket-steps-container").width() * r)
                    }).resize(), l(".qube-payment-form-trigger").on("click", function (t) {
                        t.preventDefault(), t.stopPropagation(), l(".qube-payment-form-action").click()
                    }), jQuery(function (n) {
                        n(".basket-steps").animate({
                            scrollLeft: 0
                        }, 0), n(".basket .navigation.step .nav-button").click(function () {
                            if (_that = n(this), n(this).hasClass("next")) {
                                if (!s(r)) return !1;
                                r++
                            } else r--;
                            if (n(this).hasClass("payment") || (n(".navigation.step A:eq(2)").hide(), n(".navigation.step A:eq(1)").show()), 2 === r) t();
                            else if (1 == r) {
                                n(".basket input[name=amount]").trigger("change");
                                var e = n(".basket input[name=amount]").val();
                                if (n(".basket input[name=amount]").val() < n(".basket .participants .participant").length) n(".basket .participants .participant:gt(" + (e - 1) + ")").remove();
                                else {
                                    var o = e - n(".basket .participants .participant").length;
                                    for (i = 0; i < o; i++) n(".basket .participants").append('<div class="participant row member-row"><div class="col-xs-4 form-field required"><label class="field-label">First name</label><input type="text" placeholder="" name="pname[]" value=""></div><div class="col-xs-4 form-field required"><label class="field-label">Last name</label><input type="text" value="" name="plname[]" placeholder=""/></div><div class="col-xs-4 form-field required"><label class="field-label">Email address</label><input type="text" placeholder="" name="pemail[]" value=""></div><span class="remove_row"><a title="Remove participant" href="javascript:void(0)"><i class="articon-close-menu-alt"></i></a></span></div>');
                                    n("input[placeholder], textarea[placeholder]").placeholder({
                                        blankSubmit: !0
                                    })
                                }
                            } else if (3 == r) return console.log(r), data = n(this).closest("div.basket").find("form").serializeArray(), data.push({
                                name: "oper",
                                value: "validate"
                            }), data.push({
                                name: "action",
                                value: "qube_ajax_basket"
                            }), n.ajax({
                                type: "POST",
                                url: moove_front_end_scripts.ajaxurl,
                                data: data,
                                async: "FALSE",
                                dataType: "JSON"
                            }).done(function (t) {
                                1 === t.valid ? (console.log("xx"), n("#sagepay input[name=VPSProtocol]").val(t.VPSProtocol), n("#sagepay input[name=TxType]").val(t.TxType), n("#sagepay input[name=Vendor]").val(t.Vendor), n("#sagepay input[name=Crypt]").val(t.Crypt), n("#sagepay").submit()) : alert(t.error)
                            }), !1;
                            3 != r && n(".basket-steps").animate({
                                scrollLeft: n(".basket-steps-container").width() * r
                            }, function () {
                                n(this).animate({
                                    height: n(this).find("ul.step>li:eq(" + r + ")").outerHeight()
                                }, function () {
                                    r > 0 ? n(".basket .prev").fadeIn() : n(".basket .prev").fadeOut(), n(".basket>ul.navigation>li").removeClass("active"), n(".basket>ul.navigation>li:eq(" + r + ")").addClass("active")
                                })
                            })
                        }), n(".basket .title>A.btn-small-pink.more-participants").click(function () {
                            _that = n(this), n.post(moove_front_end_scripts.ajaxurl, {
                                amount: "++",
                                oper: "add",
                                action: "qube_ajax_basket"
                            }, function (t) {
                                n(".basket .totalexvat").text(t.totalexvat), n(".basket span.total").text(t.total), n(".basket input[name=amount]").val(t.amount), n(".basket span.amount").text(t.amount), n(".basket .participants").append('<div class="participant row member-row"><div class="col-xs-4 form-field required"><label class="field-label">First name</label><input type="text" value="" name="pname[]" placeholder=""/></div><div class="col-xs-4 form-field required"><label class="field-label">Last name</label><input type="text" value="" name="plname[]" placeholder=""/></div><div class="col-xs-4 form-field required"><label class="field-label">Email address</label><input type="text" value="" name="pemail[]" placeholder=""/></div><span class="remove_row"><a href="javascript:void(0)" title="Remove participant"><i class="articon-close-menu-alt"></i></a></span></div>'), n("input[placeholder], textarea[placeholder]").placeholder({
                                    blankSubmit: !0
                                }), _that.closest(".basket-steps").animate({
                                    height: _that.closest("ul.step li").outerHeight()
                                })
                            }, "json")
                        }), n(document).on("click", ".basket .participant .remove_row A", function () {
                            if (n(".basket input[name=amount]").val() - 1 < 1) return alert("Your basket must contain at least 1 participant."), !1;
                            n.post(moove_front_end_scripts.ajaxurl, {
                                amount: "--",
                                oper: "add",
                                action: "qube_ajax_basket"
                            }, function (t) {
                                n(".basket .totalexvat").text(t.totalexvat), n(".basket span.total").text(t.total), n(".basket input[name=amount]").val(t.amount), n(".basket span.amount").text(t.amount)
                            }, "json"), n(this).closest(".participant").slideUp(function () {
                                n(this).closest(".basket-steps").animate({
                                    height: n(this).closest("ul.step li").outerHeight()
                                }), n(this).remove()
                            })
                        }), n(".basket input[name=amount]").bind("keyup change blur", function () {
                            var t = n(this).val();
                            t !== a && !0 === e(Number(t)) && (clearTimeout(o), o = setTimeout(function () {
                                n(".basket .sp-amount .spinner").show(), n.post(moove_front_end_scripts.ajaxurl, {
                                    amount: n(".basket input[name=amount]").val(),
                                    oper: "add",
                                    action: "qube_ajax_basket"
                                }, function (t) {
                                    n(".basket .sp-amount .spinner").hide(), n(".basket .totalexvat").text(t.totalexvat), n(".basket span.total").text(t.total), n(".basket span.amount").text(t.amount)
                                }, "json")
                            }, 500), a = t)
                        })
                    })
                },
                quantityButton: function () {
                    t('<div class="quantity-nav"><div class="quantity-button quantity-up"></div><div class="quantity-button quantity-down"></div></div>').insertAfter(".tranining-booking-form .quantity input"), t(".tranining-booking-form .quantity").each(function () {
                        var e = t(this),
                            i = e.find('input[type="number"]'),
                            s = e.find(".quantity-up"),
                            n = e.find(".quantity-down"),
                            o = i.attr("min"),
                            a = i.attr("max");
                        s.click(function () {
                            var t = parseFloat(i.val()),
                                s = 0;
                            isNaN(t) && (t = 0), s = t >= a ? t : t + 1, e.find("input").val(s), e.find("input").trigger("change")
                        }), n.click(function () {
                            var t = parseFloat(i.val()),
                                s = 0;
                            isNaN(t) && (t = 1), s = t <= o ? t : t - 1, e.find("input").val(s), e.find("input").trigger("change")
                        })
                    })
                },
            },
            home: {
                init: function () {
                },
                finalize: function () {
                }
            },
            about_us: {
                init: function () {
                }
            }
        },
        s = {
            fire: function (t, i, s) {
                var n, o = e;
                i = void 0 === i ? "init" : i, n = "" !== t, n = n && o[t], (n = n && "function" == typeof o[t][i]) && o[t][i](s)
            },
            loadEvents: function () {
                s.fire("common"), t.each(document.body.className.replace(/-/g, "_").split(/\s+/), function (t, e) {
                    s.fire(e), s.fire(e, "finalize")
                }), s.fire("common", "finalize")
            }
        };
    t(document).ready(s.loadEvents)
}(jQuery);
